/**
 *=================================== AUTHOR : MUSKAN KHAN===========================
 * ===================================DATE : 10 OCT 2024========================
 */
import React, { useState, useEffect } from "react";
import { Button, Col, Container, Row, Form } from "react-bootstrap";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import SparkApi from "../../api/SparkApi";
import { Link } from "react-router-dom";
import Confirm from "../Confirm";
import Barcode from "react-barcode";
import { toast, ToastContainer } from "react-toastify";
import ProductInventorylineitem from "../inventory/ProductInventorylineitem";
import ProductImageGallery from "./ProductImageGallery";
import { usePermission } from "../context/PermissionContext";

const ProductView = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const paramId = useParams();
  const [ProductRec, setProductRec] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(false); 
  const { permissionData , userInfo } = usePermission();
  const can_edit = permissionData?.Product?.can_edit;
  const can_delete = permissionData?.Product?.can_delete;
  const can_read = permissionData?.Product?.can_read;

  const handleInventoryUpdate = () => {
    // Update the state to trigger re-fetch
    setRefreshTrigger((prev) => !prev);
  };

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const resultProductById = await SparkApi.getProductById(paramId?.id);

        if (resultProductById.success) {
          setProductRec(resultProductById.records[0]);
        }
      } catch (error) {
        console.error("Error fetching product by ID:", error);
      }
    };

    if (paramId?.id) {
      fetchProduct();
    }
  }, [paramId?.id, refreshTrigger]);

  const deleteProduct = async () => {
    try {
      const result = await SparkApi.deleteProduct(ProductRec.id);

      if (result.success) {
        toast.success("Product deleted successfully");
        setTimeout(() => {
          navigate(`/products`);
        }, 2000);
      } else {
        toast.error("Failed to delete the product");
      }
    } catch (error) {
      toast.error("Internal Server Error");
    }
  };

  const editProduct = () => {
    navigate(`/createproduct`, {
      state: { editProductData: ProductRec },
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductRec((prevRec) => ({
      ...prevRec,
      [name]: value,
    }));
  };

  return (
    <div>
      { ProductRec && 
        <Container>
          <ToastContainer
            position="top-center"
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
          
          {modalShow && (
            <Confirm
              show={modalShow}
              onHide={() => setModalShow(false)}
              deleteProduct={deleteProduct}
              title="Confirm delete?"
              message="You are going to delete the record. Are you sure?"
              table="product"
            />
          )}
          <Row className="view-form">
            <Col lg={11} className="pb-3 pt-2">
              <Link className="nav-link" to="/Products">
                Home <i className="fa-solid fa-chevron-right"></i>{" "}
                <div style={{ color: "#23468c", display: "inline" }}>
                  Product
                </div>
              </Link>
            </Col>
            <Col></Col>
          </Row>
          <Row className="view-form">
            <Col></Col>
            <Col lg={8}>
              <Row className="view-form-header align-items-center">
                <Col lg={8}>
                  Product<h5>{ProductRec ? ProductRec.name : ""}</h5>
                </Col>
                <Col lg={4} className="d-flex justify-content-end">
                  {(userInfo?.userrole === "ADMIN" || can_edit) &&
                    (<Button className="btn-sm mx-2" onClick={editProduct}>
                      <i className="fa-regular fa-pen-to-square"></i>
                    </Button>
                  )}
                  {/* {helper.checkPermission(constants.MODIFY_ALL) && ( */}
                  {(userInfo?.userrole === "ADMIN" || can_delete) && 
                    (<Button
                      className="btn-sm"
                      variant="danger"
                      onClick={() => setModalShow(true)}
                    >
                      Delete
                    </Button>
                  )}
                </Col>
              </Row>
              <Row className="py-3 ibs-edit-form">
                <Col lg={6} xs={6}>
                  <label>Name</label>
                  {isEditMode ? (
                    <Form.Control
                      type="text"
                      name="name"
                      value={ProductRec.name || ""}
                      onChange={handleChange}
                    />
                  ) : (
                    <span>{ProductRec.name || <br />}</span>
                  )}
                </Col>
                <Col lg={6} xs={6}>
                  <label>Status</label>
                  {isEditMode ? (
                    <Form.Control
                      type="text"
                      name="status"
                      value={ProductRec.status || ""}
                      onChange={handleChange}
                    />
                  ) : (
                    <span>{ProductRec.status || <br />}</span>
                  )}
                </Col>
                <Col lg={6} xs={6}>
                  <label>Quantity</label>
                  {isEditMode ? (
                    <Form.Control
                      type="number"
                      name="quantity"
                      value={ProductRec.quantity || ""}
                      onChange={handleChange}
                    />
                  ) : (
                    <span>{ProductRec.quantity || 0}</span>
                  )}
                </Col>
                <Col lg={6} xs={6}>
                  <label>Type</label>

                  <span>{ProductRec.type || <br />}</span>
                </Col>
                <Col lg={6} xs={7}>
                  <label className="mt-2">Company Name</label>
                  <span>{ProductRec.company_name || <br />}</span>
                </Col>
                <Col lg={6} xs={7}>
                  <label className="mt-2">Category</label>
                  <span>{ProductRec.category || <br />}</span>
                </Col>
                <Col lg={12}>
                  <label>Description</label>
                  {isEditMode ? (
                    <Form.Control
                      as="textarea"
                      name="description"
                      value={ProductRec.description || ""}
                      onChange={handleChange}
                    />
                  ) : (<span>{ProductRec.description || <br />}</span>)
                  }
                </Col>
                <Col lg={6} xs={7}>
                  <label className="mt-2">Barcode</label>
                  {ProductRec.barcode ? (
                    <Barcode value={ProductRec.barcode} width={1} height={60} />
                  ) : (
                    <br />
                  )}
                </Col>
                <Col lg={6} xs={5}>
                  <label>Images</label>
                  <ProductImageGallery
                    productId={ProductRec?.id}
                    primaryFileId={ProductRec?.fileid}
                    primaryTitle={ProductRec?.title}
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row className="mt-5">
            <Col>
              <ProductInventorylineitem
                onInventoryUpdate={handleInventoryUpdate}
                productBarcode={ProductRec.barcode}
              />
            </Col>
          </Row>
        </Container>
      }
    </div>
  );
};
export default ProductView;
